import { useMemo } from 'react';

import type { CatalogItem } from '@/entities/catalog-item';

import { buildPeriodGroups } from '../lib/buildPeriodGroups';

/** Memoized `buildPeriodGroups` — `Code` → all of that code's period rows. */
export function usePeriodGroups(
  catalog: CatalogItem[] | undefined,
  showDiscontinued: boolean,
  isForwardCurves: boolean
): Map<string, CatalogItem[]> {
  return useMemo(
    () => buildPeriodGroups(catalog, showDiscontinued, isForwardCurves),
    [catalog, showDiscontinued, isForwardCurves]
  );
}
